<template>
  <div class="precise-query-box">
    <div class="switch">
      <div>
        <el-switch v-model="autoTranslateSwitch" @change="handleChange"> </el-switch>
        <span>{{$t('autoTranslate')}}</span>
      </div>
      <div>
        <span class="text-btn ml10" @click="resetFields">{{$i18.language('重置')}}</span>
      </div>
    </div>
    <div v-show="autoTranslateSwitch" class="translateCont">
      <div>{{ $t('components.translate.systemTran') }}</div>
      <div class="translateCont-box" v-loading="loading">
        <div v-for="(v, idx) in keyWordsList" :key="idx">
          <span class="translateCont-key-item" :class="{'translateCont-key-item-active': checkedKeyword===v.value}" @click="handleCheckKey(v)">{{v.value}}</span>
        </div>
      </div>
      <div class="translateCont-key-trans" v-if="val.value&&val.trans&&val.trans.length">
        <p class="tranLine" v-for="(item, index) in val.trans" :key="index">
          <el-checkbox v-model="item.check" class="tranCheck" @change="changeCheckTrans"
            ><span>{{ !lang?item.language:item.languageCode }}</span></el-checkbox
          >
          <span :class="[item.checkEdit ? '' : 'addBlue', 'tranBlue']"
            ><el-input class="tranInput" :readonly="item.checkEdit" style="width: 180px" @blur="loseFocuse(item, val.value)" v-model="item.translate" :placeholder="$t('dashboardCont.enterContent')"></el-input>
            <!-- 重置  originalTranslate-->
            <div>
              <span class="tranSure reset-refresh" v-show="item.checkEdit&&item.originalTranslate!==item.translate" @click.prevent.stop="resetItem(item, val.value)">
                <svg-icon name="uniE010" class="newIcon imgShow"></svg-icon>
              </span>
              <span class="tranSure" @click.prevent.stop="editlanguage(item, val.value)">
                <svg-icon v-show="item.checkEdit" name="translate-edit" class="newIcon imgShow"></svg-icon>
                <!-- <img v-show="!item.checkEdit" class="imgShow" src="@/assets/check_mark.png" /> -->
                <span v-show="!item.checkEdit" class="imgSure">{{ $t('components.translate.surceChange') }}</span>
              </span>
            </div>
          </span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import empty from '@/components/empty.vue'
export default {
  name: 'Gt50AutoTranslate',
  components: {
    empty
  },
  props: {
    autoTranslate: {
      type: Boolean,
      default: false
    },
    keyWordsList: {
      type: Array,
      default: ()=>{
        return []
      }
    }
  },
  computed: {
    keywords() {
      return this.keyWordsList.filter(item=>!item.trans||!item.trans.length).map(item=>item.value)
    },
    keys() {
      return this.keyWordsList.map(item=>item.value)
    }
  },
  watch: {
    autoTranslate() {
      this.autoTranslateSwitch = this.autoTranslate
    },
    // 监测keys
    keys: {
      handler(val, oldValue) {
        this.handleSetCheck()
        if((val && !oldValue) || (oldValue&&val&&val.join()!==oldValue.join())) {
          this.$emit('change', this.keyWordsList);
        }
      },
      immediate: true,
      deep: true
    },
    keywords: {
      handler(val, oldValue ) {
        if((val && !oldValue) || (oldValue&&val&&val.join()!==oldValue.join()) ) {
          let data = val
          if(data.length&&this.autoTranslateSwitch) {
            this.getNewTranData({ keywords: data})
          } 
        }
      },
      immediate: true,
      deep: true
    }
  },
  data() {
    return {
      val: {
        value: '',
        trans: []
      },
      lang: localStorage.getItem('language') == 'en',
      loading: false,
      tranSearch: '',
      tranList: [],
      currentQueryValue: null,
      checkedKeyword: "",
      autoTranslateSwitch: this.autoTranslate
    };
  },

  mounted() {
    
  },

  methods: {
    // 设置默认选中
    handleSetCheck() {
      // 设置默认选中的翻译词语
      let idx = this.keys.findIndex(item=>item===this.checkedKeyword)
      if(this.keyWordsList.length && (this.checkedKeyword==''|| idx <0)) {
        this.checkedKeyword = this.keyWordsList[0].value
        this.val = this.keyWordsList.filter(item=>this.checkedKeyword == item.value)[0]
      }
    },
    handleChange() {
      this.$emit("changeAuto", this.autoTranslateSwitch)
      this.getLanguages()
    },
    // 选中关键词
    handleCheckKey(val) {
      this.val = val
      this.checkedKeyword = val.value
    },
    // 获取翻译语言
    getLanguages(reset) {
      // 获取当前翻译的结果
      if(this.autoTranslateSwitch == false) {
        let data = this.keyWordsList.map(item=>{
          item.trans = []
          return item
        })
        this.$emit('update: keyWordsList', data);
        this.$emit('change', this.keyWordsList);
      }
      if (this.keyWordsList.length > 0 && this.autoTranslateSwitch == true) {
        let keywordListParams = this.keyWordsList.map((item) => {
          return item.value
        })
        let params = {
          keywords: keywordListParams,
        }
        if(reset) params.resetTranslate = true
        this.getNewTranData(params)
      }
    },
    getNewTranData(params) {
      this.loading = true
      window.cancel.getTranslateBath&&window.cancel.getTranslateBath()
      this.$api.trade.getTranslateBath(params).then((res) => {
        let data = res.data || []
        this.loading = false
        data.forEach((item, index) => {
          this.keyWordsList.forEach((itemC, idx) => {
            if (item.currentValue == itemC.value) {
              let trans = res.data[index].data.map(item=>{
                item.checkEdit = true
                return item
              })
              this.$set(this.keyWordsList[idx], 'trans',  trans)
            }
          })
        })
        // 设置默认选中的翻译词语
        // this.handleSetCheck()
        this.$emit('change', this.keyWordsList);
        this.val = this.keyWordsList.filter(item=>this.checkedKeyword == item.value)[0]
      }).catch(err=>{
        this.loading = false
      })
    },
    // 编辑翻译的选中项
    changeCheckTrans() {
      this.$emit('change', this.keyWordsList);
    },
    // 重置查询外显条件
    resetFields() {
      // 添加二次确认
      this.$confirm(this.$i18.language('重置操作将会恢复当前翻译内容中修改的内容，恢复到系统默认值，请确认是否进行。'), this.$t('tips'), {
        confirmButtonText: this.$t('sure'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
        cancelButtonClass: 'sub-confirm-btn el-button--mini',
        confirmButtonClass: 'confirm-btn el-button--mini',
      }).then(()=>{
        this.getLanguages(true)
      }).catch(err=>{})
    },
    // 重置单个词的语种翻译
    resetItem(item, value) {
      this.$confirm(this.$i18.language('是否重置为系统默认'), this.$t('tips'), {
        confirmButtonText: this.$t('sure'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
        cancelButtonClass: 'sub-confirm-btn el-button--mini',
        confirmButtonClass: 'confirm-btn el-button--mini',
      }).then(()=>{
        let { originalTranslate, languageCode} = item
        let params = {keyword: value, languageCode}
        this.$api.public.resetTranslate(params).then((res) => {
          this.$set(item, 'translate', originalTranslate);
          this.$emit('change', this.keyWordsList);
        })
      }).catch(err=>{})
    },
    // 编辑翻译
    loseFocuse(item, value) {
      this.editlanguage(item, value)
    },
    editlanguage(item, value) {
      let { translate, languageCode} = item
      item.checkEdit = !item.checkEdit
      let params = {keyword: value, updateKeyword: translate,toLanguage: languageCode}
      if(!item.checkEdit) return
      this.$api.trade.saveTranslateVal(params).then((res) => {
        this.$emit('change', this.keyWordsList);
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.precise-query-box {
  .switch {
    display: flex;
    justify-content: space-between;
    .el-switch {
      margin-right: 8px;
    }
  }
  .translateCont {
    font-size: 14px;
    color: $--font-color-text-6;
    line-height: 18px;
    margin-top: 12px;
  }
}
.translateCont-box {
  display: flex;
  position: relative;
  // height: 220px;
  padding-bottom: 5px;
  margin-top: 14px;
  overflow-x: auto;
  .translateCont-key-item {
    padding: 6px 8px;
    border-radius: 4px;
    border: 1px solid $--input-border-color;
    font-size: 14px;
    white-space: nowrap;
    color: $--font-color-primary-6;
    cursor: pointer;
    line-height: 14px;
    margin-right: 10px;
    display: inline-block;
  }
  .translateCont-key-item-active {
    color: $--color-active-6;
    border-color: $--color-active-6;
  }
}
.translateCont-key-trans {
  // position: absolute;
  left: 0;
  // margin-top: 5px;
  width: 472px;
}
.tranLine {
  //  margin-top:5px;
  display: flex;
  justify-content: space-between;
  .tranCheck {
    margin-top: 4px;
    width: 112px;
  }
  .tranBlue {
    display: inline-block;
    display: flex;
    justify-content: space-between;
    flex: 1;
    height: 30px;
    border-bottom: 1px solid #fff;
    // margin-left: 32px;
    .tranSure {
      font-weight: 400;
      color: $--color-primary-6;
      cursor: pointer;
      
    }
    .reset-refresh {
      margin-right: 10px;
    }
  }
  .addBlue {
    border-bottom: 1px solid $--color-primary-6;
  }
  .tranInput {
    height: 30px;
    /deep/ .el-input__inner {
      border: none !important;
      height: 30px;
      padding: 0px !important;
    }
  }
  .imgSure {
    margin-top: 9px;
    display: inline-block;
  }
  .imgShow {
    width: 12px;
    height: 12px;
    display: inline-block;
    margin-top: 9px;
  }
}
</style>